import { ApolloClient, InMemoryCache, HttpLink } from '@apollo/client'

// Strapi still serves v4 collection shape (data/attributes). Do NOT rewrite to *_connection —
// that renames the HTTP field while Apollo still expects the original, crashing SSG.
// Only rewrite operators this schema rejects: pagination limit, relation id filters.
const transformV4toV5 = query => {
  let q = query
  q = q.replace(/\blimit\s*:/g, 'pageSize:')
  q = q.replace(/\bid\s*:\s*\{/g, 'documentId: {')
  return q
}

// Local development does not provide a same-origin /graphql proxy. Keep the
// environment override for every deployment, while using the Msafely CMS as
// the usable fallback for article SSR/SSG and browser requests.
const defaultUri = process.env.NEXT_PUBLIC_STRAPI_URL || 'https://strapi.msafely.com/graphql'

const spyxClient = new ApolloClient({
  cache: new InMemoryCache(),
  link: new HttpLink({
    uri: defaultUri,
    fetch: (uri, options) => {
      try {
        const body = JSON.parse(options.body)
        if (body.query) {
          body.query = transformV4toV5(body.query)
          options = { ...options, body: JSON.stringify(body) }
        }
      } catch {}
      return fetch(uri, options)
    }
  })
})

export const logQuery = opts =>
  spyxClient.query(opts).catch(err => {
    console.error('[GQL Error]', err?.message || err)
    if (err?.graphQLErrors) err.graphQLErrors.forEach(e => console.error('  ', e.message))
    if (err?.networkError) console.error('  Network:', err.networkError?.message)
    throw err
  })

export default spyxClient
